import Heroone from "../../images/hero1.png";
import Herotwo from "../../images/hero2.png";
import { NavLink } from "react-router-dom";

const Hero = () => {
  return (
    <div className="py-12 lg:py-24 px-5 flex flex-col lg:flex-row items-start justify-between mb-[50px] md:mb-[-40px] lg:mb-[10px]">
      <div className="w-[100%] lg:w-[60%] text-center lg:text-left mr-[30px]">
        <h1 className="text-[40px] lg:text-[90px] font-[700] leading-[60px] lg:leading-[120px]">
          Where Every One Finds Their Fave
        </h1>
        <p className="my-[50px] text-[22px] text-gray-400 w-[100%] lg:w-[85%]">
          Explore our exclusive products to get ready for the autumn season.
        </p>
        <div className="flex flex-col lg:flex-row mb-[30px] lg:mb-0">
          <NavLink to={"/shop"}>
            <button className="bg-black text-white py-[15px] px-[25px] rounded-md mr-5 hover:bg-amber-500 hover:text-black mb-[25px]">
              Explore Collection{" "}
              <i class="fa-solid fa-arrow-up-right-from-square"></i>
            </button>
          </NavLink>
          {/* <NavLink to={"/about"}>
            <button className="text-black py-[15px] px-[45px] border-[1px] border-gray-300 font-[600] rounded-md hover:bg-amber-500">
              About Us
            </button>
          </NavLink> */}
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-[40px] relative">
        <div className="flex justify-center">
          <img
            src={Heroone}
            alt=""
            className="h-[95%] lg:h-[93%] w-[100%] lg:w-[90%] rounded-[20px] relative top-[20%]"
          />
        </div>
        <div
          className="h-[125px] md:h-[170px] w-[125px] md:w-[170px] absolute top-[3%] md:top-[1%] left-[70%] md:left-[32%] lg:left-[35%] z-20"
          id="discount"
        >
          <h6 className="absolute top-[50%] md:top-[50%] lg:top-[50%] translate-y-[-50%] left-[50%] translate-x-[-50%] md:translate-x-[-50%] text-[20px] md:text-[30px] text-center font-[700]">
            30% OFF
          </h6>
        </div>
        <div className="flex justify-center">
          <img
            src={Herotwo}
            alt=""
            className="h-[95%] lg:h-[93%] w-[100%] lg:w-[90%] rounded-[20px] relative top-[20%] md:top-[2%] md:left-[-10%] lg:top-[0%]"
          />
        </div>
      </div>
    </div>
  );
};

export default Hero;
